export { ScrollableTermsDialog } from './scrollable-terms-dialog.component';
